import isBcom from '../utils/isBcom';

function constructSizesUrl(selectedFacetSizes) {
  const categories = selectedFacetSizes[0] || '';
  const values = selectedFacetSizes[1] || '';
  const indexies = [];
  const splittedCats = categories.split(',');
  const splittedVals = values.split(',');
  splittedCats.forEach((el, index) => {
    if (el.includes('_T')) {
      indexies.push(index);
    }
  });
  const sizeCategories = indexies.map((index) => splittedCats[index]);
  const sizeValues = indexies.map((index) => splittedVals[index].split('%7C').join(';;'));
  if (sizeCategories.length && sizeValues.length) {
    return `&sizes=${sizeCategories.join('|')}!!${sizeValues.join('|')}`;
  }
  return '';
}

export default function getGeneratedUrl(product, selectedFacetSizes, colorSwatchData) {
  let url = `${product?.identifier?.productUrl}`;
  const currentColor = Object.values(product?.traits?.colors?.colorMap || [])?.find((color) => color.id === colorSwatchData?.selectedColor?.id);
  // This condition should be removed on PDP 100 % vue experiment scale
  if (!isBcom) {
    if (currentColor) {
      url += `&swatchColor=${currentColor?.name}`;
    }
  }
  if (selectedFacetSizes[0]?.length) {
    url += `${constructSizesUrl(selectedFacetSizes)}`;
  }
  return url;
}
